import React from 'react';
import { Phone, Mail, Instagram } from 'lucide-react';
import VisitorCounter from './VisitorCounter';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_6155f013-7394-403e-8ef1-e61234cc182e/artifacts/txxz08be_Ambarsariya_Logo%20Design-JPEG%20-%202.jpg"
              alt="Ambarsariya - The Taste of Amritsar"
              className="h-16 w-auto object-contain rounded-lg mb-4"
              data-testid="footer-logo"
            />
            <p className="text-gray-400 mb-4">
              Authentic North Indian Vegetarian Cuisine from Punjab's heart to your plate.
            </p>
            <div className="flex items-center gap-2 text-yellow-400">
              <span className="font-semibold">100% Pure Veg</span>
              <span className="text-2xl">🌱</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-yellow-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors">

                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors">

                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('menu')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors">

                  Menu
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('gallery')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors">

                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('reviews')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors">

                  Reviews
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('franchise')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors">

                  Franchise
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-pink-400">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-yellow-400 mt-1 flex-shrink-0" />
                <div>
                  <a
                    href="tel:+918799997457"
                    className="text-gray-400 hover:text-yellow-400 transition-colors">

                    +91 87999 97457
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-pink-400 mt-1 flex-shrink-0" />
                <div>
                  <a
                    href="mailto:ambarsariya.info@gmail.com"
                    className="text-gray-400 hover:text-pink-400 transition-colors break-all">ambarsariya.info@gmail.com


                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* Timings & Social */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-yellow-400">Opening Hours</h4>
            <p className="text-gray-400 mb-6">
              <span className="font-semibold text-white">All Days</span><br />
              11:00 AM - 11:00 PM
            </p>
            <h4 className="text-lg font-bold mb-4 text-pink-400">Follow Us</h4>
            <a
              href="https://www.instagram.com/ambarsariya.co.in"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-gray-400 hover:text-pink-400 transition-colors">

              <Instagram className="w-5 h-5" />
              <span>@ambarsariya.co.in</span>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Ambarsariya. All rights reserved.
            </p>
            <div className="flex items-center gap-4 text-sm text-gray-400">
              <span></span>
              <span>•</span>
              <span></span>
            </div>
          </div>
          <VisitorCounter />
        </div>
      </div>
    </footer>);

};

export default Footer;